import React, { useState } from 'react'
import { Dropdown } from 'semantic-ui-react'
import axios from 'axios'

function DropdownAddAdditions({placeholder, onChange, value, options}) {
    const [defaultOptions, setDefaultOptions] = useState(options);
    const [loading, setLoading] = useState(false);

    const handleChange = (e, {value}) => {
        onChange(value);
    }

    const handleAddition = (e, {value}) => {
        const { wp_rest } = window.theme_vars;
        setLoading(true);

        axios.post(`${wp_rest}social/v1/location`, {term: value}).then(({data: {data}}) => {

            const updatedOptions = Object.keys(data).filter(x => data[x]===value).map(x => ({
                text: data[x],
                value: x,
            }));
            
            setDefaultOptions(prev => ([
                ...updatedOptions,
                ...prev
            ]));
            setLoading(false);
        })
    }

    return (
        <Dropdown
            loading={loading}
            fluid
            search
            selection
            allowAdditions
            placeholder={placeholder}
            value={value}
            options={defaultOptions}
            onAddItem={handleAddition}
            onChange={handleChange}
        />
    )
}

export default DropdownAddAdditions
